import { helper } from '@ember/component/helper';
import { Grouping } from 'cio/utils/metrics/resolution';

const GROUPING_LABELS = {
  [Grouping.Hourly]: 'hour',
  [Grouping.Daily]: 'day',
  [Grouping.Weekly]: 'week',
  [Grouping.Monthly]: 'month',
};

export function metricsGroupingLabel([grouping]: [Grouping]) {
  return GROUPING_LABELS[grouping];
}

export default helper(metricsGroupingLabel);
